import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-permissions',
  templateUrl: './users-permissions.component.html',
  styleUrls: ['./users-permissions.component.css']
})
export class UsersPermissionsComponent implements OnInit {
  addEdit: boolean = false;

  constructor() { }

  ngOnInit() {
   
  }

}
